import React from "react";
import { Link as LinkIcon } from "lucide-react";

type Props = {
  className?: string;
  size?: number;
};

export default function IconLink({ className, size = 14 }: Props) {
  return <LinkIcon className={className} width={size} height={size} />;
}


